import { sojusApi } from './index';
import { UserItemType } from '../../types/UserItemType';

const userApi = sojusApi.injectEndpoints({
    endpoints: (builder) => ({
        getDashboard: builder.query<any, void>({
            query: () => `v2/user/dashboard`,
            transformResponse: (response: { data: any }, meta, arg) => response.data,
            providesTags: (result) => [
                { type: 'DashboardData', id: result.id },
                { type: 'DashboardData', id: 'LIST' },
            ],
        }),
        getDashboardTicketing: builder.query<any, string>({
            query: (projectId) => `v2/user/dashboard/ticketing/${projectId}`,
            transformResponse: (response: { data: any }, meta, arg) => response.data,
            providesTags: (result) => [
                { type: 'DashboardDataTicketing', id: result.id },
                { type: 'DashboardDataTicketing', id: 'LIST' },
            ],
        }),
        getDashboardAttendances: builder.query<any, string>({
            query: (projectId) => `v2/user/dashboard/attendances/${projectId}`,
            transformResponse: (response: { data: any }, meta, arg) => response.data,
            providesTags: (result) => [{ type: 'DashboardDataAttendances', id: 'LIST' }],
        }),
        getPersonalSettings: builder.query<UserItemType, void>({
            query: () => `v2/user/personal-settings`,
            transformResponse: (response: { data: any }, meta, arg) => response.data,
            providesTags: (result) => [{ type: 'PersonalData', id: result.id }],
        }),
        editPersonalSettings: builder.mutation<UserItemType, { payload: Partial<UserItemType> }>({
            query: ({ payload }) => ({
                url: `v2/user/personal-settings`,
                method: 'PUT',
                body: payload,
            }),
            transformResponse: (response: { data: any }) => response.data,
            invalidatesTags: (result) => [{ type: 'PersonalData', id: result?.id }],
        }),
        editPrivacySettings: builder.mutation<UserItemType, { payload: Partial<UserItemType> }>({
            query: ({ payload }) => ({
                url: `v2/user/privacy-settings`,
                method: 'PUT',
                body: payload,
            }),
            transformResponse: (response: { data: any }) => response.data,
            invalidatesTags: (result) => [{ type: 'PersonalData', id: result?.id }],
        }),
        reportIssue: builder.mutation<any, { subject: string; pageUrl: string; content: string }>({
            query: (payload) => ({
                url: `v2/user/support-request`,
                method: 'POST',
                body: payload,
            }),
            transformResponse: (response: { data: any }) => response.data,
        }),
        mergeUsers: builder.mutation<any, { payload: { userToKeep: string; userToMerge: string } }>({
            query: ({ payload }) => ({
                url: `v2/user/merge`,
                method: 'PUT',
                body: payload,
            }),
            transformResponse: (response: { data: any }) => response.data,
            invalidatesTags: (result) => [
                { type: 'PersonList', id: 'LIST' },
                { type: 'PersonData', id: result.id },
            ],
        }),
        switchUser: builder.mutation<any, string>({
            query: (userId) => ({
                url: `v2/user/switch/${userId}`,
                method: 'POST',
            }),
            transformResponse: (response) => response,
        }),
    }),
});

export const {
    useGetDashboardQuery,
    useGetDashboardTicketingQuery,
    useGetDashboardAttendancesQuery,
    useGetPersonalSettingsQuery,
    useEditPersonalSettingsMutation,
    useEditPrivacySettingsMutation,
    useReportIssueMutation,
    useMergeUsersMutation,
    useSwitchUserMutation,
} = userApi;
